
import React from 'react';
import { Input } from "@/components/ui/input";
import { UseFormReturn } from 'react-hook-form';
import { SharedFormField } from './SharedFormField';

interface TimeFieldProps<T> {
  name: string;
  label: string;
  form: UseFormReturn<T>;
}

export const TimeField = <T extends Record<string, any>>({
  name,
  label,
  form
}: TimeFieldProps<T>) => {
  return (
    <SharedFormField
      name={name}
      label={label}
      form={form}
    >
      {(field) => (
        <Input
          type="time"
          {...field}
          value={field.value || ''}
          className="w-full"
        />
      )}
    </SharedFormField>
  );
};
